// extracted by mini-css-extract-plugin
module.exports = {"cookieConsentContainer":"dp-3NKrCPkW","cookieConsentMessage":"dp-ZSXALJT5","cookieConsentButton":"dp-G42Kn89A","cookieConsentButtons":"dp-CeSTCGlQ"};